// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__dn-co","content":"GlobalSearch_content__1bOVu"};